<template>
  <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6">
    <div class="mb-5">
      <h3 class="text-lg font-bold text-neutral-900">创值规则</h3>
      <p class="text-neutral-500 text-sm mt-1">
        设置平台各项操作消耗 / 赠送的创值，保存后立即生效
      </p>
    </div>

    <div v-if="loading" class="text-neutral-400 text-sm py-6">加载中...</div>

    <div v-else class="space-y-5 max-w-xl">
      <div
        class="flex items-center justify-between gap-4 border border-neutral-200 rounded-lg p-4"
      >
        <div class="min-w-0">
          <div class="font-medium text-neutral-900">下载 / 在线使用消耗创值</div>
          <div class="text-xs text-neutral-500 mt-1">
            用户下载或在线使用一个工具需要扣除的创值；已下载过的工具不重复扣费
          </div>
        </div>
        <el-input-number
          v-model="form.downloadCost"
          :min="0"
          :max="999"
          size="default"
          class="flex-shrink-0"
        />
      </div>

      <div
        class="flex items-center justify-between gap-4 border border-neutral-200 rounded-lg p-4"
      >
        <div class="min-w-0">
          <div class="font-medium text-neutral-900">每日登录赠送创值</div>
          <div class="text-xs text-neutral-500 mt-1">
            用户每天首次登录自动赠送的创值
          </div>
        </div>
        <el-input-number
          v-model="form.signInReward"
          :min="0"
          :max="999"
          size="default"
          class="flex-shrink-0"
        />
      </div>

      <div
        class="flex items-center justify-between gap-4 border border-neutral-200 rounded-lg p-4"
      >
        <div class="min-w-0">
          <div class="font-medium text-neutral-900">工具发布奖励创值</div>
          <div class="text-xs text-neutral-500 mt-1">
            用户发布的工具审核通过后赠送给发布者的创值
          </div>
        </div>
        <el-input-number
          v-model="form.publishReward"
          :min="0"
          :max="999"
          size="default"
          class="flex-shrink-0"
        />
      </div>

      <div class="flex items-center gap-3 pt-2">
        <button
          class="px-5 py-2 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-60"
          :disabled="saving"
          @click="save"
        >
          {{ saving ? "保存中..." : "保存设置" }}
        </button>
        <button
          class="px-5 py-2 rounded-lg border border-neutral-300 text-sm text-neutral-600 hover:bg-neutral-50 transition-colors"
          @click="load"
        >
          重新加载
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";

export default {
  name: "PointRuleManager",
  data() {
    return {
      loading: true,
      saving: false,
      form: {
        downloadCost: 2,
        signInReward: 5,
        publishReward: 10,
      },
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await this.$axios({ url: "point/config", method: "GET" });
        if (res.code === 200 && res.data) {
          this.form = {
            downloadCost: res.data.downloadCost ?? 2,
            signInReward: res.data.signInReward ?? 5,
            publishReward: res.data.publishReward ?? 10,
          };
        }
      } catch (e) {
        console.error("获取创值规则失败:", e);
      }
      this.loading = false;
    },
    async save() {
      this.saving = true;
      try {
        const data = await this.$aesEncrypt({ ...this.form });
        const res = await this.$axios({
          url: "point/admin/config",
          method: "POST",
          data: { data },
        });
        if (res.code === 200) {
          ElMessage.success(res.msg || "创值规则已保存");
        } else {
          ElMessage.error(res.msg || "保存失败");
        }
      } catch (e) {
        ElMessage.error("保存失败，请检查网络或权限");
      }
      this.saving = false;
    },
  },
};
</script>
